import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const CreateOffer = () => {
  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();
  const [areas, setAreas] = useState([]);



  const [formData, setFormData] = useState({
    professional_program: "",
    area: "",
    type_contract: "",
    duration: "",
    place: "",
    salary: "",
    minimum_education: "",
    experience: "",
    functions: "",
    curso_altura: "No",
    curso_manipulacion_alimento: "No",
    professional_card: "No"
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // ⚙ Manejo de inputs
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Salario solo números
    if (name === "salary" && !/^\d*$/.test(value)) return;

    setFormData({ ...formData, [name]: value });
  };

  // 📤 Enviar formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const required = [
      "professional_program",
      "area",
      "type_contract",
      "duration",
      "place",
      "minimum_education",
      "experience",
      "functions",
      "curso_altura",
      "curso_manipulacion_alimento",
      "professional_card"
    ];

    const empty = required.filter(
      (f) => !formData[f] || formData[f].toString().trim() === ""
    );
    console.log("FORMDATA:", formData);
    console.log("VACIOS:", empty);

    if (empty.length > 0) {
      setError("Hay campos requeridos incompletos.");
      return;
    }

    try {
      const res = await authFetch(ENDPOINTS.createOffer, {
        method: "POST",
        body: JSON.stringify(formData)
      });

      if (!res.success) {
        setError(res.message);
        return;
      }

      setSuccess("Oferta creada correctamente");
      setTimeout(() => navigate("/session/offer/offers"), 1500);

    } catch (err) {
      console.error(err);
      setError("Error en el servidor");
    }
  };

useEffect(() => {
  const fetchAreas = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getarea, {
        method: "GET"
      });

      if (res.success) {
        setAreas(res.data);
      }

    } catch (err) {
      console.error("Error cargando áreas", err);
    }
  };

  fetchAreas();
}, [authFetch]);



  return (
    <div className="p-4">
      
      {/* Título + Botón Volver */}
      <div className="d-flex justify-content-between align-items-center m-3">
        <h3>Crear Oferta</h3>

        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/offer/offers")}
        >
          <i className="bi bi-arrow-left me-1"></i> Volver
        </button>
      </div>

      {/* FORMULARIO */}
      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {/* ALERTAS */}
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* === FILA 1 === */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Programa *</label>
            <input
              type="text"
              name="professional_program"
              className="form-control"
              value={formData.professional_program}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Área *</label>
            <select
                name="area"
                className="form-select"
                value={formData.area}
                onChange={handleChange}
              >
                <option value=""hidden>Selecciona...</option>

                {areas.map((area) => (
                  <option key={area.id_area} value={area.id_area}>
                    {area.name}
                  </option>
                ))}

              </select>
          </div>
        </div>

        {/* === FILA 2 === */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Tipo de contrato *</label>
            <select
              name="type_contract"
              className="form-select"
              value={formData.type_contract}
              onChange={handleChange}
            >
              <option value="" hidden>Selecciona...</option>
              <option value="Prestación de servicios">Prestación de servicios</option>
              <option value="Obra labor">Obra labor</option>
              <option value="Indefinido">Indefinido</option>
              <option value="Fijo">Fijo</option>
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label>Duración *</label>
            <input
              type="text"
              name="duration"
              className="form-control"
              value={formData.duration}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* === FILA 3 === */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Lugar *</label>
            <input
              type="text"
              name="place"
              className="form-control"
              value={formData.place}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Salario</label>
            <input
              type="text"
              name="salary"
              className="form-control"
              value={formData.salary}
              onChange={handleChange}
              placeholder="Solo números"
            />
          </div>
        </div>

        {/* === FILA 4 === */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Educación mínima *</label>
            <select
              name="minimum_education"
              className="form-select"
              value={formData.minimum_education}
              onChange={handleChange}
            >
              <option value="" hidden>Selecciona...</option>
              <option value="Bachiller">Bachiller</option>
              <option value="Tecnico">Técnico</option>
              <option value="Tecnologo">Tecnólogo</option>
              <option value="Profesional">Profesional</option>
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label>Experiencia *</label>
            <input
              type="text"
              name="experience"
              className="form-control"
              value={formData.experience}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* FUNCTIONS (SOLO) */}
        <div className="mb-3">
          <label>Funciones *</label>
          <textarea
            name="functions"
            className="form-control"
            value={formData.functions}
            onChange={handleChange}
            rows={4}
          />
        </div>

        {/* === FILA 5 (RADIOS) === */}
        <div className="row">

          {/* CURSO ALTURA */}
          <div className="col-md-4 mb-3">
            <label>Curso de altura *</label>
            <div className="d-flex gap-3 mt-1">
              <label>
                <input
                  type="radio"
                  name="curso_altura"
                  value="Si"
                  checked={formData.curso_altura === "Si"}
                  onChange={handleChange}
                />{" "}
                Si
              </label>
              <label>
                <input
                  type="radio"
                  name="curso_altura"
                  value="No"
                  checked={formData.curso_altura === "No"}
                  onChange={handleChange}
                />{" "}
                No
              </label>
            </div>
          </div>

          {/* MANIPULACIÓN */}
          <div className="col-md-4 mb-3">
            <label>Manipulación de alimentos *</label>
            <div className="d-flex gap-3 mt-1">
              <label>
                <input
                  type="radio"
                  name="curso_manipulacion_alimento"
                  value="Si"
                  checked={formData.curso_manipulacion_alimento === "Si"}
                  onChange={handleChange}
                />{" "}
                Si
              </label>
              <label>
                <input
                  type="radio"
                  name="curso_manipulacion_alimento"
                  value="No"
                  checked={formData.curso_manipulacion_alimento === "No"}
                  onChange={handleChange}
                />{" "}
                No
              </label>
            </div>
          </div>

          {/* TARJETA PROFESIONAL */}
          <div className="col-md-4 mb-3">
            <label>Tarjeta profesional *</label>
            <div className="d-flex gap-3 mt-1">
              <label>
                <input
                  type="radio"
                  name="professional_card"
                  value="Si"
                  checked={formData.professional_card === "Si"}
                  onChange={handleChange}
                />{" "}
                Si
              </label>
              <label>
                <input
                  type="radio"
                  name="professional_card"
                  value="No"
                  checked={formData.professional_card === "No"}
                  onChange={handleChange}
                />{" "}
                No
              </label>
            </div>
          </div>

        </div>

        <button type="submit" className="btn btn-outline-pink w-100 mt-4">
          Crear oferta
        </button>
      </form>
    </div>
  );
};

export default CreateOffer;
